/* file description */

import { isArray, cloneDeep } from 'lodash';
import { getTaskIdData } from '@/api/scene';
import { getModelInitData } from '@/components/SPFormWithModel/effect/useModelDefaultValues';

interface RelationType {
  iconShow: string;
  key: string;
  label: string;
  name: string;
}
interface RelationMapTypes {
  targetModule: string;
  sourceModule: string;
  relation: Array<{
    source: RelationType;
    target: RelationType;
  }>;
}

export const copyPageValue = async ({
  pageType,
  pageConfig,
  utils,
  taskInfo,
}: any) => {
  if (utils?.queryParams?.initParams) {
    const initValString = utils?.queryParams?.initParams || '{}';
    return JSON.parse(initValString);
  }

  if (
    !utils?.queryParams?.copyId ||
    !utils?.queryParams?.copyName ||
    !isArray(pageConfig?.createPageConfig?.copyMap) ||
    pageConfig?.createPageConfig?.copyMap.length === 0
  ) {
    const headCode = taskInfo?.relationTree[0]?.code;
    if (headCode) {
      const module = taskInfo.modules.find((m) => m.handle === headCode);
      const defaultValue = getModelInitData(module.fields.map((f) => ({ ...f, dataIndex: f.name })));
      return {
        [headCode]: defaultValue,
      };
    }
    return {};
  }
  const copyConfig = pageConfig?.createPageConfig?.copyMap?.find(
    (item: any) => item.name === utils?.queryParams?.copyName,
  );
  const copyId = utils?.queryParams?.copyId;
  const queryParams = utils?.queryParams;
  const values = await transformCopyValue({ copyConfig, copyId, taskInfo, copyType: 'page', queryParams });
  return values;
};

/**
 * @param copyConfig 字段映射
 * @param copyId 复制的recordId
 * @param taskInfo 任务下的信息
 * @param copyType 区分是页面复制还是事件复制
 * @returns 返回的值
 */
export const transformCopyValue = async ({ copyConfig, copyId, taskInfo, fieldName, copyType, queryParams }: any) => {
  const res = await getTaskIdData({
    task_id: copyConfig.sourceTask,
    record_id: copyId,
    fieldName,
  });
  const valueList = [res].concat(res?.records || []);
  const moduleInitList: any = {};
  (copyConfig.fieldMappingList as RelationMapTypes[]).forEach((fm) => {
    const fmVal = valueList.filter((item) => item?.moduleID === fm?.sourceModule);
    const defaultColumns = taskInfo.modules?.find((el: any) => el.handle === fm.targetModule)?.fields?.map((el: any) => ({ ...el, dataIndex: el.name })) || [];
    const defaultValues = getModelInitData(defaultColumns);
    // 生成target的字段
    const targetObj: any = {};
    fm.relation.forEach((re) => {
      targetObj[re.target.name] = undefined;
    });
    moduleInitList[fm.targetModule] = fmVal.map((value) => {
      const valJsonList = value?.values || [];
      const reObj = cloneDeep(targetObj);
      // eslint-disable-next-line guard-for-in
      for (const key in reObj) {
        // 找到source的字段
        const sourceKey = fm.relation.find((f) => f.target.name === key)?.source
          ?.name;

        reObj[key] =
          valJsonList.find((v: { name: string }) => v.name === sourceKey)
            ?.value || undefined;
        // 过滤主键数据
        // reObj[key] = valJsonList
        //   .filter((v: any) => !v.isPrimary)
        //   .find((v: { name: string }) => v.name === sourceKey)?.value || undefined;
      }
      const queryRouteMap = copyConfig.fieldMappingList[0].queryModule;
      const fromRouteQueryValues = {};
      queryRouteMap.forEach(queryKey => {
        if (queryParams[queryKey]) {
          fromRouteQueryValues[queryKey] = queryParams[queryKey];
        }
      });
      /**
       * desc: 如果事件触发的复制不需要把默认值合并，如果是页面级别的复制需要把页面的默认值合入
       */
      if (copyType === 'page') {
        return Object.assign({}, defaultValues, reObj, fromRouteQueryValues);
      }
      return Object.assign({}, reObj, fromRouteQueryValues);
    });
  });

  const mainModuleCode = taskInfo.modules.find(
    (module: any) => module.moduleID === taskInfo.mainModuleId,
  )?.handle;

  moduleInitList[mainModuleCode] = moduleInitList?.[mainModuleCode]?.[0] || {};
  // 拼装成页面的数据格式
  return moduleInitList;
};
